import React from 'react';

const EmptyModule = () => <div> </div>;
export default EmptyModule;
